// 太平文化
<template>
  <div>
     <input type="file"
           name="fileUploader"
           id="fileUploader"
           accept=".xls,.xlsx"
        @change="toJSON($event)"/>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
      data(){
        return{
           
        }
    },
    methods:{
        toJSON(e){
            let file = e.target.files[0]
            let reader = new FileReader()
            reader.onload = event  => {

                try {
                    const { result } = event.target;
                    // 以二进制流方式读取得到整份excel表格对象
                    const workbook = XLSX.read(result, { type: 'binary' });
                    // 存储获取到的数据
                    let data = {};
                    // 遍历每张工作表进行读取（这里默认只读取第一张表）
                    for (const sheet in workbook.Sheets) {
                        let tempData = [];
                        // esline-disable-next-line
                        if (workbook.Sheets.hasOwnProperty(sheet)) {
                            // 利用 sheet_to_json 方法将 excel 转成 json 数据
                            data[sheet] = tempData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        }
                    }
                    //上传成功,data为上传后的数据
                    const newData = JSON.parse(JSON.stringify(data))
                    // newData.map(item => {
                    //     delete item['__rowNum__']
                    // })
                    // 最终获取到并且格式化后的 json 数据 newData
                 
                   console.log(JSON.stringify(newData))
                } catch (e) {
                    console.log('不符合标准JSON格式')
                }

            }
            reader.readAsBinaryString(file);
        }
    },
    filters:{
       
    }, 
    created(){
    },
    mounted(){
        
    }, 
    components:{},
}
</script>

<style>
  
</style>


// WEBPACK FOOTER //
// src/view/getjson.vue